import type { PeopleAccess } from '@/shared/types/policy';
import type { Person } from '@/store/people/types';
import {
  Dropdown,
  DropdownTrigger,
  Button,
  DropdownMenu,
  DropdownItem,
} from '@/components/ui';
import { Icon } from '@iconify/react/dist/iconify.js';
import type { ActionKey } from '.';

export function PersonActions({
  item: person,
  onAction,
  access,
}: {
  item: Person;
  onAction: (item: Person, key: ActionKey) => void;
  access: PeopleAccess;
}) {
  const allowEdit = access?.people_edit === 'allow';
  const allowCommentCreate = access?.comment_create === 'allow';
  const allowView = access?.people_view === 'allow';
  const items: { key: ActionKey; label: string }[] = [];

  if (allowEdit) {
    items.push({ key: 'edit', label: 'Edit Details' });
    items.push({ key: 'tags', label: 'Edit Tags' });
  }

  if (allowView) {
    items.push({ key: 'view', label: 'View' });
  }

  if (allowCommentCreate) {
    items.push({ key: 'comment', label: 'Add Comment' });
  }

  items.push({ key: 'reminder', label: 'Add Reminder' });

  // items.push({ key: 'milestones', label: 'Add Milestone' });

  if (!items.length) {
    return <></>;
  }

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button isIconOnly variant='light'>
          <Icon icon='mdi:dots-vertical' />
        </Button>
      </DropdownTrigger>
      <DropdownMenu items={items}>
        {(item) => (
          <DropdownItem
            key={item.key}
            onPress={() => onAction(person, item.key as ActionKey)}
          >
            {item.label}
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
}
